import {QuestionModel} from "./QuestionModel";

export class QuestionTextAreaModel extends QuestionModel {
  constructor(position: number, question: string, required: boolean, label: string) {
    super(position, question, required, label);
  }
}
